fragment discountFields on Discount {
  value
  type
  family
  id
}
